/* Citric · agrupa publicaciones hermanas (mismo producto en distinto color/talla)
   - En listados: muestra una sola tarjeta por producto con sus colores y tallas.
   - En la página del producto: selector de Color y Talla que lleva a la publicación correspondiente. */
(function () {
  var norm = function (s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); };
  var SIZE = /^(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|5xl|ch|med|g|eg|xg|xxg|unitalla|\d{1,2}(\.5)?|\d+m)$/;
  var NA = /^(n\/a|na|talla|tallas)$/;
  var COLORS = {
    negro: '#111', negra: '#111', black: '#111', blanco: '#fff', blanca: '#fff', white: '#fff', hueso: '#f3efe6', crema: '#f3e9d2',
    azul: '#1e4fd8', blue: '#1e4fd8', marino: '#1b2a4a', navy: '#1b2a4a', celeste: '#7ec8f0', turquesa: '#20b2aa', aqua: '#20b2aa', menta: '#98e0c8',
    rojo: '#d32f2f', roja: '#d32f2f', red: '#d32f2f', vino: '#7b1e3a', guinda: '#7b1e3a', coral: '#ff7f50',
    rosa: '#f06292', pink: '#f06292', fucsia: '#e91e8c', morado: '#7b1fa2', morada: '#7b1fa2', lila: '#b39ddb',
    verde: '#2e7d32', olivo: '#6b7a3a', militar: '#6b7a3a', amarillo: '#f5c400', amarilla: '#f5c400', mostaza: '#d4a017',
    naranja: '#f57c00', gris: '#9e9e9e', grey: '#9e9e9e', gray: '#9e9e9e', cafe: '#6d4c41', beige: '#d8c3a5', arena: '#d8c3a5',
    khaki: '#c3b091', caqui: '#c3b091', camel: '#c19a6b', dorado: '#d4af37', oro: '#d4af37', plateado: '#c0c0c0', plata: '#c0c0c0',
    multicolor: 'conic-gradient(#f44336,#ffeb3b,#4caf50,#2196f3,#9c27b0,#f44336)', mixcolr: 'conic-gradient(#f44336,#ffeb3b,#4caf50,#2196f3,#9c27b0,#f44336)',
    claro: null, oscuro: null
  };
  function isColorWord(w) { return Object.prototype.hasOwnProperty.call(COLORS, w); }
  function isTok(t) {
    var l = norm(t).replace(/[(),]/g, '');
    if (!l) return false;
    return SIZE.test(l) || NA.test(l) || l.split('/').every(isColorWord);
  }
  function colorCss(name) {
    var parts = norm(name).split(/[\s/]+/).filter(function (w) { return COLORS[w]; });
    if (!parts.length) return '';
    if (parts.length === 1) return COLORS[parts[0]];
    return 'linear-gradient(135deg,' + COLORS[parts[0]] + ' 50%,' + COLORS[parts[1]] + ' 50%)';
  }
  /* Separa "Playera X - Blanco XL" en base "Playera X", color "Blanco", talla "XL" */
  function parse(title) {
    title = (title || '').replace(/\s+/g, ' ').trim();
    var head = title, tail = '';
    var i = title.lastIndexOf(' - ');
    if (i > 0) {
      var suf = title.slice(i + 3);
      if (/^dise[nñ]o \d+$/i.test(suf) || suf.split(' ').every(isTok)) { head = title.slice(0, i); tail = suf; }
    }
    var words = head.split(' ');
    if (!tail) {
      var rem = [];
      while (words.length > 2 && isTok(words[words.length - 1])) rem.unshift(words.pop());
      tail = rem.join(' ');
    }
    var color = [], size = [];
    if (/^dise[nñ]o \d+$/i.test(tail)) color.push(tail);
    else tail.split(' ').forEach(function (t) {
      if (!t) return;
      var l = norm(t).replace(/[(),]/g, '');
      if (NA.test(l)) return;
      if (SIZE.test(l)) size.push(t.toUpperCase()); else color.push(t);
    });
    var base = words.join(' ');
    var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s; };
    return {
      base: base,
      key: norm(base).replace(/[^a-z0-9]+/g, ' ').trim(),
      color: color.map(cap).join(' '),
      size: size.join(' '),
      sizeLabel: /modelo$/i.test(base) ? 'Modelo' : 'Talla'
    };
  }
  window.citricParseTitle = parse;

  /* ---------- Listados: una tarjeta por producto ---------- */
  function setTitle(card, full, base) {
    card.querySelectorAll('p, h3, span, a').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.trim() === full) el.textContent = base;
    });
  }
  function groupCards() {
    document.querySelectorAll('product-card:not([data-citric-g])').forEach(function (card) {
      var link = card.querySelector('a.product-card__link');
      if (!link) return;
      var full = (link.getAttribute('aria-label') || '').trim();
      var p = parse(full);
      card.setAttribute('data-citric-g', p.key);
      var item = card.closest('li') || card;
      var list = item.parentElement || document.body;
      list._citric = list._citric || {};
      var g = list._citric[p.key];
      if (!g) {
        g = list._citric[p.key] = { card: card, full: full, base: p.base, colors: [], sizes: [], n: 0, sizeLabel: p.sizeLabel };
      } else {
        item.style.display = 'none';
        item.setAttribute('data-citric-hidden', '1');
      }
      g.n++;
      if (p.color && g.colors.indexOf(p.color) === -1) g.colors.push(p.color);
      if (p.size && g.sizes.indexOf(p.size) === -1) g.sizes.push(p.size);
      if (g.n > 1) renderGroupCard(g);
    });
  }
  function renderGroupCard(g) {
    setTitle(g.card, g.full, g.base);
    var box = g.card.querySelector('.citric-group-chips');
    if (!box) {
      box = document.createElement('div');
      box.className = 'citric-chips citric-group-chips';
      var content = g.card.querySelector('.product-card__content') || g.card;
      content.appendChild(box);
    }
    var html = '';
    if (g.colors.length > 1) {
      g.colors.slice(0, 6).forEach(function (c) {
        var css = colorCss(c);
        html += css ? '<span class="citric-dot" title="' + c + '" style="background:' + css + '"></span>' : '<span class="citric-chip">' + c + '</span>';
      });
      if (g.colors.length > 6) html += '<span class="citric-chip citric-chip--more">+' + (g.colors.length - 6) + '</span>';
    }
    if (g.sizes.length > 1) {
      sortSizes(g.sizes);
      g.sizes.slice(0, 6).forEach(function (s) { html += '<span class="citric-chip">' + s + '</span>'; });
      if (g.sizes.length > 6) html += '<span class="citric-chip citric-chip--more">+' + (g.sizes.length - 6) + '</span>';
    }
    if (!html) html = '<span class="citric-chip citric-chip--more">' + g.n + ' opciones</span>';
    box.innerHTML = html;
  }

  /* ---------- Página de producto: selector Color / Talla ---------- */
  function initProductPicker() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m || document.querySelector('.citric-picker')) return;
    var handle = decodeURIComponent(m[1]);
    var h1 = document.querySelector('main h1');
    if (!h1) return;
    var full = h1.textContent.trim();
    var cur = parse(full);
    if (!cur.key) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'search?type=product&view=citric&q=' + encodeURIComponent(cur.base);
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (txt) {
      var list;
      try { list = JSON.parse(txt.trim()); } catch (e) { return; }
      var sibs = [];
      list.forEach(function (x) {
        var p = parse(x.t);
        if (p.key !== cur.key) return;
        if (sibs.some(function (s) { return s.h === x.h; })) return;
        sibs.push({ h: x.h, u: x.u, a: x.a, color: p.color, size: p.size });
      });
      if (!sibs.some(function (s) { return s.h === handle; })) sibs.push({ h: handle, u: location.pathname, a: true, color: cur.color, size: cur.size });
      if (sibs.length < 2) return;
      renderPicker(h1, cur, handle, sibs);
    }).catch(function () {});
  }
  var ORDER = ['XXS', 'XS', 'CH', 'S', 'M', 'MED', 'L', 'G', 'XL', 'EG', 'XG', 'XXL', '2XL', 'XXG', 'XXXL', '3XL', '4XL', '5XL'];
  function sortSizes(sizes) {
    return sizes.sort(function (a, b) {
      var ia = ORDER.indexOf(a), ib = ORDER.indexOf(b);
      if (ia > -1 && ib > -1) return ia - ib;
      var na = parseFloat(a), nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return a < b ? -1 : 1;
    });
  }
  function uniq(arr) { return arr.filter(function (v, i) { return v && arr.indexOf(v) === i; }); }
  function pick(sibs, want) {
    var c = sibs.filter(want);
    return c.filter(function (s) { return s.a; })[0] || c[0];
  }
  function renderPicker(h1, cur, handle, sibs) {
    var colors = uniq(sibs.map(function (s) { return s.color; }));
    var sizes = uniq(sibs.map(function (s) { return s.size; }));
    sortSizes(sizes);
    var html = '';
    if (colors.length > 1 || (colors.length === 1 && sizes.length > 1)) {
      var colorLabel = colors.every(function (c) { return /^dise/i.test(c); }) ? 'Diseño' : 'Color';
      html += '<div class="citric-picker__row"><div class="citric-picker__label">' + colorLabel + ': <b>' + (cur.color || '') + '</b></div><div class="citric-picker__opts">';
      colors.forEach(function (c) {
        var t = pick(sibs, function (s) { return s.color === c && s.size === cur.size; }) || pick(sibs, function (s) { return s.color === c; });
        var exact = sibs.some(function (s) { return s.color === c && s.size === cur.size && s.a; });
        var css = colorCss(c);
        html += '<a class="citric-opt' + (c === cur.color ? ' is-active' : '') + (exact || !cur.size ? '' : ' is-na') + '" href="' + t.u + '">' +
          (css ? '<span class="citric-dot" style="background:' + css + '"></span>' : '') + c + '</a>';
      });
      html += '</div></div>';
    }
    if (sizes.length > 1) {
      html += '<div class="citric-picker__row"><div class="citric-picker__label">' + cur.sizeLabel + ': <b>' + (cur.size || '') + '</b></div><div class="citric-picker__opts">';
      sizes.forEach(function (sz) {
        var t = pick(sibs, function (s) { return s.size === sz && s.color === cur.color; }) || pick(sibs, function (s) { return s.size === sz; });
        var ok = sibs.some(function (s) { return s.size === sz && s.color === cur.color && s.a; });
        html += '<a class="citric-opt citric-opt--size' + (sz === cur.size ? ' is-active' : '') + (ok ? '' : ' is-na') + '" href="' + t.u + '">' + sz + '</a>';
      });
      html += '</div></div>';
    }
    if (!html) return;
    var box = document.createElement('div');
    box.className = 'citric-picker';
    box.innerHTML = html;
    var anchor = document.querySelector('main product-inventory') || h1.closest('.group-block, [class*="group"]') || h1;
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    h1.textContent = cur.base;
  }

  function init() { groupCards(); initProductPicker(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; groupCards(); }, 200);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
